/* eslint-disable prettier */
/**
 * Created by calhosh on 4/14/2017.
 * ES MX resource file
 */
export const labels = {
	title: "EY Canvas Economics",
	status: "Estado",
	header: "encabezado",
	canvas: "Canvas",
	canvasEconomics: "Economia de Canvas",
	badRequest: "mala petición",
	errorBanner: "errores de {0}",
	userProfileDropdown: {
		myProfile: "Mi perfil",
		signOut: "Cierre la sesión"
	},
	clientCode: "Código de cliente",
	hours: "Horas",
	local: "local",
	currency: "Monedas",
	rate: "tasa",
	forecast: "Pronostico",
	variance: "variación",
	edit: "Editar",
	arrowUp: "Flecha arriba",
	budget: "presupuesto",
	priorBudget: "Presupuesto anterior",
	currentBudget: "Presupuesto actual",
	summary: "resumen",
	actual: "actual",
	priorActual: "Real anterior",
	currentActual: "Real actual",
	remaining: "restante",
	adjustment: "ajuste",
	estimate: "estimado",
	isRequired: "{0} Es requerido",
	isPositiveInteger: "{0} Es requerido y debe ser entero no negativo.",
	isPositiveDecimal: "Es requerido y debe ser un número positivo con 2 decimales.",
	in: "en",
	id: "Identificación",
	currentYear: "Año actual",
	priorYear: "Año anterior",
	budgetHierarchy: "Jerarquía presupuestaria",
	executionBudgetHierarchy: "Jerarquía presupuestaria de ejecución",
	noContentAvailable: "Sin contenido disponible",
	viewMore: "Ver más",
	budgetExecutionPhase: "Presupuesto para todos los objetos dentro de {0}",
	details: "Detalles",
	unallocated: "Sin asignar",
	none: "ninguno.",
	thousands: "miles",
	millions: "Millones",
	lakhs: "Lakhs",
	crores: "Millones de Rupias",
	budgetObjectName: "Nombre del objeto presupuestario",
	editActivityCodes: "Editar códigos de actividad",
	save: "Salvar",
	send: "Enviar",
	cancel: "Cancelar",
	searchActivityCodes: "Buscar código de actividad",
	noActivityCodesAvailable: "Sin códigos de actividad disponibles",
	select: "Seleccionar",
	engagementCode: "Código de engagement",
	engagementCodeName: "Nombre en clave de compromiso",
	activityCode: "Código de actividad",
	activityCodeDescription: "Descripción del código de actividad",
	searchActivityCodesPlaceholderText: "Buscar códigos de actividad",
	addMember: "Agregar miembro",
	closeLabel: "cerrar",
	cancelLabel: "Cancelar",
	seachInputRequired: "Se requiere entrada de búsqueda",
	nameOrEmail: "Nombre o correo electrónico",
	emailForExternal: "Correo electrónico",
	noRecord: "No se han encontrado resultados",
	userSearchPlaceholder: "Introduzca su nombre o correo electrónico y presione enter para ver los resultados.",
	userSearchPlaceholderForExternal: "Introduzca el correo electrónico presione enter para ver los resultados.",
	clearAllValues: "Borrar todos los valores",
	clear: "Resolver",
	inValidEmail: "Por favor, introduzca el correo electrónico válido",
	invalidClientCode: "Código de cliente inválido",
	railSearchText: "buscar",
	open: "abrir",
	remove: "eliminar",
	leave: "Dejar",
	delete: "Borrar",
	markAsCompleted: "Marcar como completado",
	budgetedHours: "Horas presupuestadas",
	forecastedHours: "Horas previstas",
	actualHours: "Horas reales",
	ftaVariance: "Variación FTA",
	ftaVarianceTooltip: "Presupuesto versus variación real",
	usedHours: "Horas incurridas",
	etcHours: "Horas etc",
	createProjectCard: "Crear proyecto",
	plusClients: "+{0} Clientes",
	plusCodes: "+{0} códigos de cliente",
	clientNames: "Nombres de clientes:",
	clientName: "Nombre del cliente:",
	clientNameLabel: "Nombre del cliente",
	clientCodes: "Códigos de cliente:",
	clientCodeCard: "Código del cliente:",
	financialAnalysis: "Análisis financiero",
	billingExpenses: "Facturación y gastos",
	independence: "Independencia",
	timeChargedCanvasIndependenceStatus: "Estado general de independencia del proyecto por EY Canvas y código financiero",
	independenceStatusFromCanvasLabel: "Estado de independencia de EY Canvas",
	independenceRequired: "Independencia requerida",
	validatedCanvas: "Validado en EY Canvas",
	notInvited: "No invitado",
	notApplicable: "No aplicable",
	incomplete: "Incompleto",
	other: "Otro",
	financialCodesDisplayed: "Códigos financieros mostrados",
	independenceStatusChangeReasonLabel: "Cambiar estado",
	independenceStatusChangeReasonDescription: "Seleccione la razón de finalización para el miembro del equipo seleccionado",
	changeReasonLabel: "Razón",
	clarificationLabel: "Aclaración (opcional)",
	characterCount: "{0} de 200 caracteres",
	expandAll: "Expandir todo",
	collapseAll: "Contraer todo",
	canvasEngagements: "Compromisos de EY Canvas",
	independenceCompleted: "Independencia completada",
	engagementName: "Nombre del compromiso",
	engagementIndependenceStatus: "Por estado de independencia de compromiso",
	noAssociatedClients: "Sin cliente asociado",
	noCanvasEngagementsIdentified: "No se identificaron compromisos de EY Canvas",
	placeholderForSearch: "Búsqueda de Miembro del equipo",
	exportToExcel: "Exportar a Excel",
	all: "Todo",
	updateSelected: "Actualización seleccionada",
	updateAll: "Actualizar todo",
	customizeTable: "Personalizar tabla",
	canvasEngagementName: "Nombre del compromiso de EY Canvas",
	displayBy: "Mostrar datos por",
	financialDetails: "Detalles financieros",
	actualHoursToDate: "Horas reales hasta la fecha",
	byWeekEndingDate: "Fecha de finalización de la semana",
	ClickAndDrag: "Haga clic y arrastre un área del gráfico para acercarla",
	etc: "Tiempo estimado para finalizar",
	auditProgress: "Progreso de EY Canvas",
	tasksAndMilestones: "Tareas & Milestones",
	milestonesOverdue: "Milestones vencidos",
	milestoneOverdue: "milestones vencidos",
	inProgress: "En progreso",
	inReview: "En revisión",
	Complete: "Completo",
	assignments: "Asignaciones",
	assignment: "asignaciones",
	assignmentsOverdue: "Asignaciones atrasadas",
	assignmentOverdue: "Asignaciones vencidas",
	overdue: "Vencido",
	requestOverdue: "Solicitud vencida",
	requestsOverdue: "Solicitudes vencidas",
	total: "total",
	complete: "Completo",
	closed: "Cerrado",
	Unassigned: "Sin asignar",
	unassigned: "no asignado",
	sent: "enviado",
	totalTask: "Tarea total",
	collaboration: "colaboración",
	received: "recibido",
	accepted: "aceptado",
	outstanding: "excepcional",
	unsentDrafts: "Borradores no enviados",
	draft: "Borrador",
	drafts: "borradores",
	returned: "regresado",
	draftRequests: "borrador de solicitudes",
	percent: "Porcentaje",
	preparer: "preparador",
	reviewer: "Revisor",
	NoDataForSelectedOptions: "No hay información disponible para las opciones seleccionadas.",
	NoAssignmentDataForSelectedOptions: "Compromiso no está utilizando la función asignación",
	NoCollabDataForSelectedOptions: "El compromiso no está utilizando la función de colaboración.",
	tasks: "Tareas",
	totalTasks: "Tareas totales",
	requests: "Solicitudes",
	requestSent: "solicitudes enviadas",
	requestsSent: "Solicitudes enviadas",
	expandDetails: "Expandir detalles",
	onlyProjectAdministratorsCanEdit: "Solo los administradores de proyectos pueden editar",
	onlyProjectAdministratorsCanDelete: "Solo los administradores de proyectos pueden eliminar proyectos",
	userOptions: "Opciones de usuario",
	userOptionsDropdown: {
		userSettings: "Configuración de usuario",
		delegateAccess: "Administrar delegados",
		privacyNotice: "Aviso de Privacidad",
		signOut: "Cerrar sesión"
	},
	delegateToInstruction: "Delega el acceso a tus colegas para que puedan validar los códigos de compromiso en tu nombre. Estos delegados podrán validar todos los códigos de compromiso a los que tenga acceso.",
	delegateFromInstruction: "Los siguientes usuarios han delegado sus derechos para validar los códigos de contratación.",
	delegateAccess: "Administrar delegados",
	addDelegates: "Agregar delegados",
	addAnother: "Agregar nuevo delegado",
	hideMyDelegate: "Ocultar mis delegados",
	showMyDelegate: "Mostrar a mis delegados",
	duplicateUser: "Delegado ya agregado",
	informationRequired: "Esta información es obligatoria",
	delegateTo: "Delegado a",
	delegateFrom: "Delegado de",
	noDelegatesAdded: "No se agregaron delegados.",
	noDelegationReceived: "No se recibió ninguna delegación.",
	removeDelegateMessgae: "¿Está seguro de que desea eliminar este delegado? Una vez eliminados, ya no podrán validar los códigos de compromiso financiero en su nombre.",
	removeDelegateTitle: "Quitar un delegado",
	delegate: "Delegado",
	saveAndClose: "Guardar y cerrar",
	resetZoom: "Restablecer zoom",
	exportData: "Exportar datos",
	rankCode: "Código de rango",
	userGui: "GUI de usuario",
	email: "Correo electrónico",
	globalAnsr: "Global ANSR",
	globalCost: "Costo global",
	globalMargin: "Margen global",
	localAnsr: "Local ANSR",
	localCost: "Costo local",
	localMargin: "Margen local",
	weekEnding: "Final de semana",
	welcomeToEconomics: "Bienvenido a EY Canvas Economics",
	adminPortal: "portal administrativo",
	home: "Inicio",
	enterFirstNameText: "Ingrese el nombre, apellido o dirección de correo electrónico del usuario y presione enter para buscar",
	addBtn: "Agregar",
	cancelBtn: "Cancelar",
	close: "Cerca",
	selectRole: "Rol",
	upsText: "Ups!",
	sufficientRightsToAccess: "No tiene derechos suficientes para acceder a esta página",
	detailedInformation: "La información detallada puede variar de los datos resumidos presentados debido a las diferencias de tiempo de cuándo se ponen a disposición los datos.",
	noResultFound: "Ningún resultado coincide con los criterios de búsqueda",
	loading: "Cargando…",
	search: "Buscar",
	softwareUpdate: "Actualizaciones de software",
	updateLater: "Actualizar más tarde",
	updateNow: "Actualiza ahora",
	updateMsg: "Las actualizaciones de software están disponibles para EY Canvas Economics. Seleccione Actualizar ahora para descargar e instalar las actualizaciones. La página se actualizará.",

	eycanvasEngagements: "Compromisos de EY Canvas",
	eycanvasEngagement: "Compromiso de EY Canvas",
	expandView: "Expandir vista",
	noFinancialCodesDisplay: "No hay códigos financieros para mostrar",
	expand: "Expandir",
	collapse: "Contraer",
	bulkSendIndependenceLabel: "Confirmación de independencia de envío masivo",
	independenceStatusInviteUserLabel: "Agregar miembro interno del equipo solo como Independencia",
	independenceStatusInviteUserDescription: "Identifique el rol del miembro del equipo a continuación. Este usuario se agregará al {0} compromiso de Canvas con las restricciones de 'Solo independencia' y se le notificará para completar su independencia",
	clickToInviteUser: "para enviar confirmación de la independencia",
	click: "Clic",
	invitePending: "Invitación pendiente",
	engagementRolePlaceholder: "Rol de compromiso",
	engagementRoleRequiredErrorMessage: "Seleccione el rol en el compromiso para el miembro del equipo seleccionado",
	engagementInvitationSuccessToastMessage: "Ha enviado con éxito la(s) confirmación(es) de independencia.",
	engagementInvitationFailureToastMessage: "No se pudo enviar la(s) confirmación(es) de independencia, por favor vuelva a intentarlo. Si el problema persiste, comunícate con el servicio de asistencia.",
	independenceInviteConfirmationMessage: "Se ha enviado la confirmación de la independencia. Se espera respuesta.",
	engagementRoleRequiredOverAllErrorMessage: "No se ha seleccionado un rol en el compromiso para uno o más usuarios. Seleccione el rol de compromiso en el menú desplegable para continuar con el envío de la confirmación de Independencia.",
	administrativeContractor: "Contratista administrativo",
};

export const errors = {
	default: "Ocurrió un error. Por favor, póngase en contacto con mesa de ayuda.",
	102: "Proyecto no válido.",
	106: "Autorización de RBAC denegada.",

	1001: "Usuario no encontrado.",
	1002: "Error en la llamada para todos los usuarios",
	1003: "El GUI del usuario no puede ser nulo",
	1004: "La solicitud no puede ser nula.",
	1005: "No se pudo crear el usuario porque ya existe un usuario con el mismo GUI.",
	1006: "Se encontró más de un usuario con el mismo GUI.",
	1007: "El usuario no está activo. Actualice la página e inténtelo de nuevo. Si el error persiste, póngase en contacto con Service Desk.",
	1008: "El formato de número seleccionado no es válido. Actualice la página e inténtelo de nuevo. Si el error persiste, póngase en contacto con Service Desk.",
	1009: "El formato de redondeo seleccionado no es válido. Actualice la página e inténtelo de nuevo. Si el error persiste, póngase en contacto con Service Desk.",
	1010: "El formato de moneda seleccionado no es válido. Actualice la página e inténtelo de nuevo. Si el error persiste, póngase en contacto con Service Desk.",
	1011: "El formato de fecha seleccionado no es válido. Actualice la página e inténtelo de nuevo. Si el error persiste, póngase en contacto con Service Desk.",
	1012: "El idioma seleccionado no es válido. Actualice la página e inténtelo de nuevo. Si el error persiste, póngase en contacto con Service Desk.",
	1013: "El nombre es demasiado corto o demasiado largo. Por favor, inténtelo de nuevo.",
	1014: "El apellido es demasiado corto o demasiado largo. Por favor, inténtelo de nuevo.",
	1015: "El formato de número negativo seleccionado no es válido. Actualice la página e inténtelo de nuevo. Si el error persiste, póngase en contacto con Service Desk.",
	1016: "El Usuario no pudo ser actualizado porque no existe.",
	1017: "Se ha producido un error al obtener las preferencias del usuario. La llamada de API ha fallado.",
	1018: "Se ha producido un error al crear el usuario. La llamada de API ha fallado.",
	1019: "Se ha producido un error al actualizar las preferencias del usuario. La llamada de API ha fallado.",
	1020: "El usuario no está activo. Actualice la página e inténtelo de nuevo. Si el error persiste, póngase en contacto con el servicio de asistencia.",
	1021: "El valor del tema seleccionado no es válido. Actualice la página e inténtelo de nuevo. Si el error persiste, póngase en contacto con el servicio de asistencia.",
	1022: "El valor de la moneda seleccionada no es válido. Actualice la página e inténtelo de nuevo. Si el error persiste, póngase en contacto con el servicio de asistencia.",
	1023: "El usuario no está autorizado para eliminar el miembro del equipo solicitado del proyecto.",
	1024: "Se ha producido un error al crear el usuario delegado. Se ha realizado un error en la llamada a la API.",
	1025: "La lista de usuarios delegados no debe estar vacía.",
	1026: "El nombre de un usuario es demasiado largo o demasiado corto.",
	1027: "La GUI de un usuario no es válida.",
	1028: "La dirección de correo electrónico de un usuario es demasiado larga o demasiado corta.",
	1029: "El ID de usuario no debe estar vacío.",
	1030: "El nombre de usuario no debe estar vacío.",
	1031: "La dirección de correo electrónico del usuario no debe estar vacía.",
	1032: "El usuario no forma parte del delegado para recolección para quitar el acceso.",
	1033: "El usuario no forma parte del delegado de recolección para quitar el acceso.",
	1034: "El usuario ya forma parte del delegado para recolección.",
	1035: "La longitud del ID de usuario no es apropiada. Inténtelo de nuevo con el ID de usuario correcto.",
	1036: "El usuario que ha iniciado sesión no puede formar parte de la lista. Inténtelo de nuevo más tarde.",
	1040: "No tiene derechos de administrador. Póngase en contacto con Help Desk.",

	7001: "Error en la llamada a los metadatos del compromiso.",
	7006: "EY Canvas no es accesible en este momento. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con Service Desk.",

	8003: "Error al obtener detalles del compromiso del API de CDS.",
	8006: "EY Canvas no es accesible en este momento. Actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con el Service Desk.",
	8004: "Código de compromiso no encontrado. Si este es un código de mercurio, asegúrese de que se incluyó el tipo de compromiso. Inténtalo de nuevo y si el problema persiste, póngase en contacto con la mesa de ayuda.",
	8007: "Error al obtener los detalles de interacción de la API de CDS.",
	8008: "Error de conexión. Actualice y vuelva a intentarlo. Si el problema persiste, póngase en contacto con mesa de ayuda.",

	9001: "La solicitud no puede ser nula",
	9002: "El campo código de proyecto de cliente no puede ser nulo",
	9003: "El campo Nombre del proyecto no puede ser null.",
	9004: "El campo de porcentaje no puede ser null.",
	9005: "El campo de tasa no puede ser nulo.",
	9006: "El presupuesto no tiene ningun compromiso seleccionado asociado.",
	9007: "El identificador único de compromiso no puede ser null.",
	9008: "El nombre del cliente del compromiso no puede ser null.",
	9009: "La descripción del compromiso no puede ser null.",
	9010: "El identificador único del compromiso del cliente no puede ser null.",
	9011: "El sistema del compromiso relacionado no puede ser nulo.",
	9012: "El identificador único de compromiso relacionado no puede ser null.",
	9013: "El nombre del compromiso relacionado no puede ser nulo.",
	9014: "El identificador único de cliente del compromiso relacionada no puede ser null.",
	9015: "El nombre del cliente del compromiso relacionado no puede ser nulo.",
	9016: "El compromiso relacionado agregado por no puede ser nulo.",
	9017: "Uno o más compromisos de EY Canvas no son válidos.",
	9018: "Uno o más códigos de compromiso relacionados no son válidos.",
	9019: "El porcentaje de proyectos debe ser mayor que cero.",
	9020: "El porcentaje de proyectos no debe tener más de dos dígitos decimales.",
	9021: "La tasa de proyectos debe ser mayor que cero.",
	9022: "ProjectId no es válido.",
	9023: "La llamada para el análisis financiero falló.",
	9024: "No se encontraron los detalles del proyecto.",
	9025: "Error al obtener la llamada para el encabezado.",
	9026: "Ningún resultado coincide con los criterios de búsqueda.",
	9027: "Tipo de agregación no válido.",
	9028: "El usuario actual no tiene acceso al proyecto.",
	9029: "No se encontraron los detalles de facturación del proyecto.",
	9030: "No se han encontrado filtros financieros del proyecto.",
	9031: "Un nombre de usuario es demasiado largo o demasiado corto.",
	9032: "Una GUI de usuario no es válida.",
	9033: "Una dirección de correo electrónico de los usuarios es demasiado larga o demasiado corta.",
	9034: "Al menos un miembro del equipo debe tener el rol de administrador del proyecto.",
	9035: "Usted es el último usuario administrador de proyectos activo del proyecto. Elimine el proyecto para eliminarlo de su página de destino. Si no puede eliminar el proyecto, comuníquese con mesa de ayuda.",
	9036: "Elimine uno o más compromisos de EY Canvas. La cantidad supera el {0}.",
	9037: "Por favor, elimine algunos miembros del equipo porque la cantidad supera los {0}.",
	9038: "Por favor, elimine alguno códigos de compromiso porque la cantidad excede los {0}.",
	9039: "El número de usuarios del proyecto debe ser mayor que cero.",
	9040: "Los códigos financieros no validados no deben ser cadenas nulas o vacías, y su longitud no puede superar los 50 caracteres.",
	9041: "El identificador del proyecto no debe estar vacío.",
	9042: "No se puede completar la eliminación. Inténtelo de nuevo y si el error persiste, póngase en contacto con el servicio de asistencia.",
	9043: "El usuario actual no tiene acceso para editar un proyecto.",
	9044: "Error en la llamada de Detalles financieros del proyecto.",
	9045: "El estatus del proyecto no es válido.",
	9046: "El estatus de usuario del proyecto no es válido.",
	9047: "Rol de usuario de proyecto no válido.",
	9048: "El nombre del proyecto debe estar dentro de los 500 caracteres.",
	9049: "El nombre del usuario del proyecto no puede estar vacío.",
	9050: "El apellido del usuario del proyecto no puede estar vacío.",
	9051: "La GUI del usuario del proyecto no puede estar vacía.",
	9052: "El correo electrónico del usuario del proyecto no puede estar vacío.",
	9053: "El indicador de administrador de usuario del proyecto no puede estar vacío.",
	9054: "La cuenta privilegiada no se puede agregar como usuario del proyecto.",
	9055: "No se encontraron los filtros de gastos del proyecto.",
	9056: "El cuerpo de la solicitud de revisión de independencia del proyecto no puede estar vacío.",
	9058: "Los códigos financieros no son válidos.",
	9063: "La independencia completa tiene un valor racional inválido.",
	9064: "El tipo completo de independencia tiene un valor no válido.",
	9065: "No se encontraron los filtros de gastos del proyecto.",
	9066: "El número de identificadores de compromiso vinculados al proyecto es mayor que el número máximo permitido.",
	9067: "Operación de parche no válida.",
	9068: "Algún usuario ya actualizó el estado, actualice la página para ver el estado más reciente.",
	9069: "Error en el API parche de Independencia",
	9070: "Códigos financieros duplicados asociados al compromiso Canvas.",
	9071: "Solo los códigos financieros individuales asociados al compromiso Canvas se pueden marcar como código primario.",
	9072: "Los códigos financieros primarios asociados a los compromisos EY Canvas no son válidos.",
	9073: "Códigos financieros duplicados no validados.",
	9074: "Usuarios duplicados.",
	9075: "Un correo electrónico de usuario no es válido.",
	9076: "El cuerpo de la solicitud del creador de usuarios del compromiso no puede estar vacío.",
	9077: "La solicitud de creación de usuarios de compromiso tiene usuarios duplicados.",
	9078: "El rol de usuario del compromiso no es válido.",
	9079: "Compromiso Canvas no válido.",
	9080: "El compromiso no está asignado al proyecto.",
	9081: "Error en la solicitud de creación de usuarios del compromiso.",
	9082: "La sesión ha expirado por inactividad. Actualice la página y vuelva a intentarlo. Si el problema persiste, póngase en contacto con el servicio de asistencia.",

	/*Admin error codes*/
	14001: "Usuario no encontrado",
	14002: "Error en la llamada del usuario administrador",
	14003: "El usuario administrador encontrado es InActive",
	14004: "Error al crear el usuario administrador",
	14005: "El primer nombre es demasiado corto o demasiado largo. Inténtelo de nuevo",
	14006: "El apellido es demasiado corto o demasiado largo. Inténtelo de nuevo",
	14007: "El identificador de rol de administrador no es válido",
	14008: "El usuario seleccionado ya es administrador. Por favor revise.",
	14009: "Error en la llamada de búsqueda del usuario administrador",
	14010: "La interfaz gráfica de usuario no puede estar vacía",
	14011: "La interfaz gráfica de usuario debe ser mayor que cero",
	14012: "El identificador de usuario no es válido. Inténtelo de nuevo",
	14013: "La dirección de correo electrónico no es válida. Inténtelo de nuevo",
	14014: "El usuario que ha iniciado sesión no es lo mismo que el usuario administrador",
	14015: "Error en la llamada de búsqueda del proyecto de administración",
	14016: "El usuario administrador ya existe, pero es InActive",
	14017: "El administrador solo puede ser una cuenta de usuario privilegiada",
	14018: "El identificador del rol de administrador no puede estar vacío.",
	14019: "El usuario que ha iniciado sesión no es administrador del sistema.",
	14020: "Cuenta privilegiada del solicitante no valida.",
	14021: "El administrador solo puede ser una cuenta de usuario privilegiada.",
	14023: "Error al eliminar los roles de administrador existentes.",
	14024: "Error al agregar roles de administrador actualizados.",
	14025: "El ID de usuario de administrador no puede estar vacío.",

	/*PAANS error codes*/
	15001: "El Servicio de Autorización, Aprobaciones y Notificación de Políticas de EY no está disponible en este momento. No podemos confirmar si se han completado todas las políticas relevantes. Si no ha revisado las directivas pertinentes, actualice la página e inténtelo de nuevo. Si el problema persiste, póngase en contacto con Mesa de ayuda."
};

export const roundingOptions = [{
	value: 'none',
	label: "ninguno"
},
{
	value: 'thousands',
	label: "En miles"
},
{
	value: 'millions',
	label: "En millones"
},
{
	value: 'lakhs',
	label: "En lakhs"
},
{
	value: 'crores',
	label: "En crores"
}
];

export const displayLanguages = [{
	displayLanguageId: 1,
	label: "Inglés",
	value: 'en-us'
},
{
	displayLanguageId: 4,
	label: "Francés",
	value: 'fr-ca'
},
{
	displayLanguageId: 5,
	label: "Español",
	value: 'es'
},
{
	displayLanguageId: 7,
	label: "Portugués",
	value: 'pt-br'
},
{
	displayLanguageId: 8,
	label: "Japonés",
	value: 'ja'
},
{
	displayLanguageId: 9,
	label: "Chinesezh-cn",
	value: 'zh-cn'
},
{
	displayLanguageId: 10,
	label: "Chinesezh-tw",
	value: 'zh-tw'
},
{
	displayLanguageId: 11,
	label: "Hebreo",
	value: 'he'
},
{
	displayLanguageId: 12,
	label: "Coreano",
	value: 'ko'
}
];

export const numberFormats = [{
	value: '1,234,567,890',
	label: "numbericStlye1",
	title: '1,234,567,890'
},
{
	value: '1.234.567.890',
	label: "numbericStlye3",
	title: '1.234.567.890'
},
{
	value: '1,23,45,67,890',
	label: "numbericStlye7",
	title: '1,23,45,67,890'
},
{
	value: '1 234 567 890',
	label: "numbericStlye2",
	title: '1 234 567 890'
}
];

export const dateFormats = [{
	value: 'MM/dd/yyyy',
	label: 'MM/DD/YYYY'
},
{
	value: 'dd/MM/yyyy',
	label: 'DD/MM/YYYY'
},
{
	value: 'yyyy/MM/dd',
	label: 'YYYY/MM/DD'
}
];

export const negativeNumberFormats = [{
	value: '(1.1)',
	label: '(1.1)'
},
{
	value: '-1.1',
	label: '-1.1'
},
{
	value: '- 1.1',
	label: '- 1.1'
},
{
	value: '1.1-',
	label: '1.1-'
},
{
	value: '1.1 -',
	label: '1.1 -'
}
];

export const currencyFormats = [{
	value: "global",
	label: "Global"
},
{
	value: "local",
	label: "Local"
}
];

export const themeOptions = {
	light: "Claro",
	dark: "oscuro"
};

export const currencyOptions = {
	global: "global",
	local: "local"
};

export const currencyDisplayOptions = [{
	value: 'Global',
	label: "Global"
},
{
	value: 'Local',
	label: "Local"
}
];

export const statusValues = [{
	isActive: true,
	label: "Activo"
},
{
	isActive: false,
	label: "Inactivo"
}
];

export const financialOptions = {
	serviceLine: "Línea de servicio",
	subServiceLine: "Línea de subservicios",
	teamMember: "Miembro del equipo",
	rank: "Rango"
};

export const roles = {
	1: "Socio a cargo",
	2: "Socios de Engagement",
	3: "director ejecutivo",
	4: "director",
	5: "Gerente senior",
	6: "Gerente",
	7: "Senior",
	8: "personal",
	9: "interno",
	10: "Revisor de Calidad",
	11: "Otro socio",
	12: "GDS-Personal",
	13: "Advisory (ITRA, TAS, Capital Humano u Otros)",
	14: "Impuesto",
	15: "Servicios de apoyo ejecutivo",
	16: "Consejo General",
	17: "Revisor de calidad de auditoría",
	21: "Supervisor de Auditoría Interna",
	22: "Personal de auditoría interna",
	23: "Regulador",
	24: "Otros (por ejemplo, revisión de diligencia debida)",
	25: "oficina",
	26: "área",
	27: "industria",
	28: "Nacional",
	29: "global",
	30: "GDS - senior",
	31: "GDS - Gerente"
};

export const serviceLines = [{
	value: 0,
	label: "Todas las líneas de servicio"
},
{
	value: 1,
	label: "Advisory"
},
{
	value: 2,
	label: "Assurance"
},
{
	value: 3,
	label: "GCO"
},
{
	value: 4,
	label: "TAS"
},
{
	value: 5,
	label: "TAX"
},
{
	value: 6,
	label: "Otro"
}
];

export const serviceLinesByServiceLineCode = [{
	code: 'Not available',
	label: "No disponible"
},
{
	code: 'ASU',
	label: "Auditoría"
},
{
	code: 'TAS',
	label: "Estrategia y Transacciones (SaT)"
},
{
	code: 'TAX',
	label: "Impuesto"
},
{
	code: 'ADV',
	label: "Consultoría"
},
];

export const userRanks = [{
	id: '11',
	name: "Socio"
},
{
	id: '12',
	name: "Socio"
},
{
	id: '13',
	name: "Director Ejecutivo"
},
{
	id: '21',
	name: "Gerente Sr."
},
{
	id: '32',
	name: "Gerente"
},
{
	id: '36',
	name: "Gerente de Impuestos"
},
{
	id: '4',
	name: "Contratista"
},
{
	id: '41',
	name: "Senior 3"
},
{
	id: '42',
	name: "Senior"
},
{
	id: '43',
	name: "Staff 2"
},
{
	id: '44',
	name: "Staff"
},
{
	id: '45',
	name: "Senior 2"
},
{
	id: '46',
	name: "Staff 3"
},
{
	id: '49',
	name: "Asociado"
},
{
	id: '5',
	name: "Contratista administrativo"
},
{
	id: '51',
	name: "Interno"
},
{
	id: '52',
	name: "Soporte y administración"
},
{
	id: '53',
	name: "Interno (CBS)"
},
{
	id: '55',
	name: "Jefe de administración"
},
{
	id: '56',
	name: "Administrador avanzado"
},
{
	id: '57',
	name: "Administrador intermedio"
},
{
	id: '58',
	name: "Entrada de administrador"
},
{
	id: '61',
	name: "Director"
},
{
	id: '62',
	name: "Director Asociado"
},
{
	id: '63',
	name: "Subgerente"
},
{
	id: '64',
	name: "Supervisor Asociado"
},
{
	id: '65',
	name: "Sr. Asociado"
},
{
	id: '66',
	name: "Asociado"
},
{
	id: 'Not available',
	name: "No disponible"
}
];

export const financialAnalysis = {
	noResultFound: "No se han encontrado resultados para las opciones seleccionadas",
	allServiceLines: "Todas las líneas de servicio",
	allSubServiceLines: "Todas las sub lineas de servicios",
	allMembers: "Todos los miembros",
	allAvailable: "Todo disponible",
	allAdded: "Todo añadido",
	selectAll: "Seleccionar todo",
	noResult: "No se han encontrado resultados",
	noneSelected: "Ninguna seleccionada",
	clearAllSeleted: "Borrar # seleccionado",
	showSelected: "Mostrar seleccionado",
	allRanks: "Todos los rangos"
};

export const independenceStatus = [{
	value: 1,
	label: "Incompleto - No invitado"
},
{
	value: 2,
	label: "Incompleto - En curso"
},
{
	value: 3,
	label: "Completado - Otro"
},
{
	value: 4,
	label: "Completado - Validado en EY Canvas"
}
];

export const eycanvasIndependenceStatus = [{
	value: 1,
	label: "Incompleto"
},
{
	value: 2,
	label: "No se han identificado asuntos"
},
{
	value: 3,
	label: "Asunto Identificado - Acción Pendiente"
},
{
	value: 4,
	label: "Asunto resuelto - Acceso denegado"
},
{
	value: 5,
	label: "Asunto resuelto - Acceso concedido"
},
{
	value: 6,
	label: "No aplicable"
},
{
	value: 7,
	label: "Restaurado"
},
{
	value: 8,
	label: "Invalidar"
},
{
	value: 9,
	label: "Anterior - No hay asuntos identificados"
},
{
	value: 10,
	label: "Anterior - Asunto Identificado - Acción Pendiente"
},
{
	value: 11,
	label: "Anterior - Asunto resuelto - Acceso concedido"
},
{
	value: 12,
	label: "Anterior - Asunto resuelto - Acceso denegado"
}
];

export const availableUserRoles = [{
	value: 1,
	label: "Socio a cargo",
	displayOrder: 9
},
{
	value: 2,
	label: "Socio de compromiso",
	displayOrder: 8
},
{
	value: 3,
	label: "Director Ejecutivo",
	displayOrder: 5
},
{
	value: 4,
	label: "Principal",
	displayOrder: 6
},
{
	value: 5,
	label: "Gerente Senior",
	displayOrder: 4
},
{
	value: 6,
	label: "Gerente",
	displayOrder: 3
},
{
	value: 7,
	label: "Senior",
	displayOrder: 2
},
{
	value: 8,
	label: "Staff",
	displayOrder: 1
},
{
	value: 10,
	label: "Revisor de la calidad del compromiso",
	displayOrder: 10
},
{
	value: 11,
	label: "Otro socio",
	displayOrder: 7
},
{
	value: 12,
	label: "GDS - Staff",
	displayOrder: 13
},
{
	value: 16,
	label: "Consejero General",
	displayOrder: 12
},
{
	value: 17,
	label: "Revisor de calidad de auditoría",
	displayOrder: 11
},
{
	value: 30,
	label: "GDS - Senior",
	displayOrder: 14
},
{
	value: 31,
	label: "GDS - Gerente",
	displayOrder: 15
}
]

export const employmentStatus = [{
	value: 'A',
	label: "Activo"
},
{
	value: 'D',
	label: "Terminado"
},
{
	value: 'L',
	label: "Permiso de ausencia"
},
{
	value: 'T',
	label: "Terminado"
},
{
	value: 'P',
	label: "Permiso de ausencia"
},
{
	value: 'R',
	label: "Terminado"
},
{
	value: 'U',
	label: "Permiso de ausencia"
},
]

export const independenceStatusDropdown = [{
	label: "Incompleto",
	options: [{
		value: 1,
		label: "Incompleto - No invitado"
	},
	{
		value: 2,
		label: "Incompleto - En curso"
	}
	]
},
{
	label: "Completar",
	options: [{
		value: 3,
		label: "Completado - Otro"
	}]
}
];

export const customizedTableOptions = [{
	id: 2,
	label: "Estado de independencia de EY Canvas"
},
{
	id: 3,
	label: "Firma miembro"
},
{
	id: 4,
	label: "País"
},
{
	id: 5,
	label: "Horas cargadas"
},
{
	id: 6,
	label: "Situación general de Independencia"
},
{
	id: 7,
	label: "Fecha de confirmación"
},
{
	id: 8,
	label: "Situación laboral"
},
{
	id: 9,
	label: "Actualizado por"
},
{
	id: 10,
	label: "Fecha de actualización"
}
];

export const independenceStatusChangeReasons = [{
	value: 1,
	label: "Completado fuera de EY Canvas - No hay asuntos identificados",
	isDisplayed: true
},
{
	value: 7,
	label: "Completado fuera de EY Canvas - Asuntos identificados",
	isDisplayed: true
},
{
	value: 8,
	label: "Completado fuera de EY Canvas - Asuntos resueltos",
	isDisplayed: true
},
{
	value: 2,
	label: "Siempre una persona cubierta",
	isDisplayed: true
},
{
	value: 3,
	label: "Ya no está en la Firma",
	isDisplayed: true
},
{
	value: 4,
	label: "Excedencia",
	isDisplayed: true
},
{
	value: 5,
	label: "Terminado",
	isDisplayed: false
},
{
	value: 6,
	label: "Otra cosa",
	isDisplayed: false
}
];

export const common = {
	selected: "Seleccionar",
	cancel: "Cancelar",
	checkbox: {
		selectAllOn: "Seleccionar todo",
		selectAllOff: "Deseleccionar todo"
	},
	clear: "Borrar",
	close: "cerrar",
	nav: {
		projectName: "Nombre del proyecto"
	},
	pagination: {
		show: "Mostrar",
		iconHover: {
			first: "Primera Pagina",
			previous: "Página anterior",
			next: "Página siguiente",
			last: "Última página"
		}
	},
	search: {
		clear: "Borrar búsqueda",
		buttonTitle: "buscar",
		placeholder: "Buscar",
		noResultsPlaceholder: "No se han encontrado resultados"
	},
	table: {
		remove: "Eliminar",
		noDataPlaceholder: "Datos no disponible",
		noResultsPlaceholder: "No se han encontrado resultados"
	},
	toggleSwitch: {
		no: "No",
		yes: "Si"
	},
	wizard: {
		next: "Continuar",
		back: "Regresa",
		finish: "Terminar"
	},
	unsavedChanges: "Cambios no guardados",
	unsavedChangesDescription: "Tiene cambios no guardados que se perderán si decide continuar. ¿Estás seguro de que quieres deshacer tus cambios?"
};

export const project = {
	myProjects: "Mis proyectos",
	priorProjects: "Proyectos anteriores",
	searchForBudgets: "Buscar",
	emptyContainer: "No tienes presupuestos activos. Haga clic en 'Crear presupuesto' para empezar.",
	noResultsFound: "No se encontraron resultados.",
	create: {
		title: "Crear proyecto",
		clientCode: "Código de cliente",
		clientCodeInfo: "Los códigos reflejado no se reconocen. Utilice el código del sistema que emitió el código (es decir, Mercury o GFIS).",
		clientName: "Nombre del cliente",
		clientNamePlaceholder: "Introduzca el código de cliente para buscar el nombre del cliente",
		name: "Nombre del proyecto",
		rate: "Tasa por defecto por hora",
		rateInfo: "La tarifa predeterminada por hora se utilizará para calcular la cantidad de horas presupuestadas. Esta tasa debe calcularse como las tarifas a cobrar divididas por el total de horas previstas.",
		percentage: "Porcentaje de realización esperado",
		percentageInfo: "El porcentaje de realización esperado se aplicará al valor de tiempo de las horas cobradas en Mercurio o GFIS.",
		relateEngagementsInstructionalText: "Seleccione una o mas compromisos de EY Canvas que se usarán en este proyecto. Las métricas de estos compromisos se presentarán junto con los datos financieros. Solo se mostrarán los compromisos actualmente accesibles.",
		selectClientAndWorkspaceInstructionalText: "Seleccione un cliente y un espacio de trabajo para identificar los compromisos de EY Canvas relacionados con este proyecto.",
		engagementPanelPlaceholder: "Seleccione un cliente y un área de trabajo para mostrar los compromisos sugeridos.",
		engagementPanelNoResultsFound: "No se han encontrado resultados",
		emptyEngagements: "No hay compromisos de EY Canvas disponibles. Cree un nuevo compromiso en EY Canvas para empezar.",
		selectClient: "Seleccionar cliente",
		selectWorkspace: "Seleccionar espacio de trabajo",
		selectEngagements: "Seleccionar compromiso",
		selectedEngagements: "Añadir compromiso",
		selectedEngagementError: "Seleccione una o más compromisos para continuar",
		searchEngagements: "Buscar Compromisos",
		searchUsers: "Buscar usuarios",
		engagementLabel: "{0} | ID: {1}",
		addBtn: "agregar",
		removeBtn: "eliminar",
		clientLbl: "Cliente",
		engagementCodeLbl: "Código de engagement",
		engagementTypeCodeLbl: "Tipo de engagement",
		engagementNameLbl: "Nombre del compromiso",
		engagementId: "identificación",
		addedByLbl: "Añadido por",
		engagementDescriptionLbl: "Descripción del compromiso",
		systemLbl: "Sistema",
		noEngagementsLabel: "Relacionar códigos de compromisos con este proyecto.",
		step4InstTxt: "Seleccione uno o varios códigos de compromiso que se asociarán al proyecto.",
		relatedEngagementCodesSubtitle: "Códigos de compromisos relacionados",
		relatedEngagementCodeLink: "Enumere el código de compromiso de Mercury o GFIS. Los códigos reflejados no se reconocen.",
		unauthorizedModalHeader: "Usuario no autorizado",
		unauthorizedText: "No estas autorizado para relacionar",
		allowedUsersText: "A continuación se incluye una lista de personas que pueden realizar esta acción.",
		closeBtn: "cerrar",
		validateBtn: "Validar",
		relatedEngagementAddLabel: "Enumere el código de compromiso de Mercury o GFIS. Los códigos reflejado no se reconocen.",
		todayLbl: "Hoy",
		NoEmailMessage: "Sin correo electrónico proporcionado",
		noEngagementsAdded: "Sin compromisos añadidos",
		selectToImport: "Seleccione un compromiso de EY Canvas para importar usuarios a este proyecto.",
		addMember: "Si un usuario no está activo en el compromiso de EY Canvas, {0} agregarlo.",
		addedMembers: "Miembros añadidos",
		employeeName: "miembro",
		role: "Rol",
		manageTeamInstructionalText: "Seleccione miembros activos del equipo del compromisos relacionadas con EY Canvas, siga la descripción siguiente para agregar otros miembros del equipo que no formen parte de los comrpomisos de EY Canvas.",
		currentUser: "Usuario actual",
		canvasEngagements: "Compromisos de EY Canvas",
		wizardSteps: [
			{
			stepName: "Paso 1",
			stepDescription: "Introduzca los detalles del proyecto",
			active: true
		},
		{
			stepName: "Paso 2",
			stepDescription: "Seleccionar compromisos de EY Canvas"
		},
		{
			stepName: "Paso 3",
			stepDescription: "Gestionar el acceso",
			relatedEngagementCodesSubtitle: "Códigos de compromisos relacionados",
			relatedEngagementCodeLink: "Enumere el código de compromiso de Mercury o GFIS. Los códigos reflejados no se reconocen.",
			unauthorizedModalHeader: "Usuario no autorizado",
			unauthorizedText: "No estas autorizado para relacionar",
			allowedUsersText: "La siguiente es una lista de individuos que pueden tomar esta acción.",
			close: "cerrar"
		},
		{
			stepName: "Paso 4",
			stepDescription: "Conéctese a Mercury/GFIS"
		},
		{
			stepName: 'Step 5',
			stepDescription: "Asociar códigos de compromiso a compromisos de EY Canvas",
			isExit: true
		}
		],
		ratePerHour: "Tarifa por hora",
		realizationPercentage: "Porcentaje de realización"
	},
	stepOne: {
		enterProjectName: "Introduzca el nombre de un proyecto para continuar"
	},
	stepTwo: {
		addCanvasEngagements: "Añadir compromisos de EY Canvas al proyecto",
		editCanvasEngagements: "Editar los compromisos de EY Canvas con el proyecto",
		selectCanvasEngagements: "Se muestran los compromisos de EY Canvas a los que tiene acceso.  Seleccione uno o más compromisos de EY Canvas para incluirlos en el proyecto.",
		noCanvasEngagements: "No hay compromisos de EY Canvas disponibles. Continúe con el siguiente paso para continuar con la configuración del proyecto.",
		noCanvasEngagementsSelected: "No se han seleccionado compromisos de EY Canvas",
		noSearchResultsFoundLeftRail: "No se han encontrado resultados",
		clientName: "Cliente",
		workspace: "Workspace",
		engagementCode: "Código del engagement",
		canvasEngagementName: "Compromiso de EY Canvas",
		changes: "Cambios",
		tooltipMessages: {
			clientName: "Nombre de cliente",
			clientCode: "Código de cliente",
			engagementCode: "Código de Engagement",
			engagementDescription: "Nombre del Engagement",
			workspaceID: "Identificación del Workspace",
			workspaceDescription: "Nombre del Workspace"
		}
	},
	stepThree: {
		editTeamMembers: "Editar miembros del equipo al proyecto.",
		editTeamMembersWhoWillHaveAccess: "Edita a los miembros del equipo que tendrán acceso al proyecto. Para agregar un miembro del equipo que no forme parte de los compromisos asociados de EY Canvas, use la función de búsqueda en el lado derecho. Los administradores del proyecto tendrán la capacidad de administrar el proyecto (por ejemplo, agregar o eliminar miembros del equipo).",
		addTeamMembers: "Añadir miembros del equipo al proyecto.",
		addTeamMembersWhoWillHaveAccess: "Agregue miembros del equipo que tendrán acceso al proyecto. Para agregar un miembro del equipo que no forme parte de los compromisos asociados de EY Canvas, use la función de búsqueda en el lado derecho. Los administradores del proyecto tendrán la capacidad de administrar el proyecto (por ejemplo, agregar o eliminar miembros del equipo).",
		noCanvasEngagementsSelected: "No se han seleccionado compromisos de EY Canvas",
		noSearchResultsFoundLeftRail: "No se han encontrado resultados",
		addOtherTeamMembers: "Agregar otros miembros del equipo que no formen parte de los compromisos conectados de EY Canvas",
		member: "Miembro",
		projectAdministrator: "Administrador de proyectos",
		clickHere: "haga clic aquí",
		nameOrEmail: "Nombre y correo electrónico",
		addNewMember: "Agregar",
		firstName: "Nombre",
		lastName: "Apellido",
		inviteAndClose: "Invitar y cerrar",
		inviteAndAddAnother: "Invitar & agregar otro",
		clear: "Limpio"
	},
	stepFour: {
		engagementCode: "Código del engagement",
		clientName: "Cliente",
		validation: "Estatus",
		independenceOnly: "Solo independencia",
		noEngagementCodes: "No hay códigos de Engagement agregados al proyecto.",
		addNewMember: "Agregar",
		addEngagementManually: "Añadir códigos del Engagement",
		addEngagementCodes: "Añadir códigos del Engagement",
		editEngagementCodes: "Editar códigos de compromiso",
		validateEngagement: "Valide todos los códigos de proyecto agregados. Solo se pueden validar los códigos de proyecto a los que tenga acceso en GFIS/Mercury. Si un código de proyecto se identifica como \'Independencia únicamente\', los detalles relacionados con ese código de proyecto (como los miembros del equipo y las horas relacionadas facturadas) se incluirán en el resumen de independencia para este proyecto de ahorro, pero no se incluirán en el informe. capacitación financiera.",
		informationalMessage: "Para Mercury, incluya el tipo de Engagement prefijado al código de Comprimos (por ejemplo, E-12345678)",
		noCanvasEngagements: "No se han agregado compromisos de EY Canvas al proyecto",
		engagementCodePlaceholder: "Ingrese un código de Engagement",
		validate: "Validar",
		engagementCodeRequired: "Código de engagement requerido",
		searchNoResults: "No se han encontrado resultados"
	},
	stepFive: {
		title: "Asociar códigos de compromiso a compromisos de EY Canvas",
		description: "Los códigos de compromiso principales asociados a cada uno de los compromisos conectados de EY Canvas se muestran a continuación. Para asociar códigos de participación adicionales a una participación de EY Canvas, utilice la siguiente funcionalidad de arrastrar y soltar.",
		financialCodes: {
			searchButtonTitle: "Buscar",
			searchButtonPlaceholder: "Buscar por código de compromiso financiero",
			header: "Códigos de compromiso",
			noRecords: "No se han identificado códigos de compromiso",
			canvasEngagements: "Compromisos de EY Canvas",
			noResults: "No se han encontrado resultados"
		},
		canvasEngagements: {
			searchButtonTitle: "Buscar",
			clearButtonTitle: "Claro",
			noResults: "No se han encontrado resultados",
			searchButtonPlaceholder: "Buscar por compromiso de Cliente o Canvas de EY",
			header: "Clientes y compromisos",
			noRecords: "No hay compromisos de EY Canvas asociados al proyecto",
			noEngagementCodes: "Sin códigos de compromiso asociados",
			primary: "Primario",
			displayUnassociatedEngagements: "Mostrar los compromiso(s) de EY Canvas sin códigos financieros asociados"
		}
	},
	deleteProject: "Eliminar proyecto",
	deleteDescription: "¿Está seguro de que desea eliminar el proyecto para todos los usuarios?",
	deleteDescText: "Esta acción no se puede deshacer.",
	delete: "borrar",
	cancel: "Cancelar",
	close: "cerrar",
	confirm: "Confirmar",
	leaveProject: "Dejar",
	leaveDescription: "¿Estás seguro de que quieres dejar este proyecto? Seguirá estando disponible para los miembros de su equipo.",
	change: "Cambio",
	changes: "Cambios"
};

export const users = {
	settings: {
		title: "Configuración del usuario",
		firstName: "Nombre",
		lastName: "apellido",
		displayLanguage: "Idioma de visualización",
		numberFormat: "Formato de número",
		negativeNumberFormat: "Formato de número negativo",
		currencyFormat: "Formato de tipo de cambio",
		dateFormat: "Formato de fecha",
		roundingFormat: "Formato de redondeo",
		save: "Salvar",
		cancel: "Cancelar",
		errorMessageSelect: "Seleccione un valor.",
		errorMessageInput: "Introduzca un valor válido.",
		isRequired: " es necesario.",
		preferences: "Preferencias",
		yourDelegates: "Sus delegados",
		yourDelegatesDescription: "Usuarios que hayan concedido autoridad para recuperar datos financieros de códigos de participación a los que tienen acceso a Mercurio o GFIS",
		delegationsFromOthers: "Delegación de otros",
		delegationsFromOthersDescription: "Usuarios que le han dado autoridad para recuperar datos financieros de compromisos a los que tienen acceso a Mercury o GFIS",
		noUsersIdentified: "Sin usuarios identificados",
		addADelegate: "Añadir un delegado",
		theme: "Tema",
		preferredCurrency: "Moneda preferida",
		status: "Estado"
	}
};

export const projectSummary = {
	filter: {
		filterFinancialAuditData: "Filtrar clientes",
		filter: "filtro",
		searchPlaceholder: "Buscar",
		searchClearHoverText: "Limpiar",
		searchHoverText: "buscar",
		unvalidated: "Sin validar",
		noData: "No hay compromiso de EY Canvas asociado",
		noResults: "No se encontraron resultados",
		noInformationAvailable: "No hay información disponible para las opciones seleccionadas.",
		independence: "Independencia",
		noDataFound: "No se han encontrado datos",
	},
	roundingType: "redondeo:",
	roundingFormats: {
		none: "ninguno.",
		thousands: "En miles",
		millions: "En millones",
		lakhs: "En lakhs",
		crores: "En millones de rupias"
	},
	updatedDateType: {
		financialDateLabel: "Datos financieros",
		updatedOn: "actualizado el",
		canvasDateLabel: "Datos de EY Canvas"
	},
	keyPerformanceIndicators: {
		noValue: '-',
		totalEngagementRevenue: {
			ter: "TER",
			actualTER: "TER real",
			billed: "Facturado",
			actualBilling: "Facturación real",
			totalEngagementRevenue: "Ingresos totales de Engagement (tarifas + gastos)",
			forecastedTER: "TER pronosticado"
		},
		margin: {
			margin: "Margen",
			target: "Objetivo"
		},
		globalDeliveryService: {
			gds: "Uso de GDS",
			globalDeliveryService: "Global Delivery Service"
		}
	},
	currency: "moneda:",
	globalCurrency: "Global",
	localCurrency: "local",
	noDataAvailable: "No hay datos disponibles para los filtros seleccionados",
	actualHours: "Horas actuales",
	etc: "etc",
	ftaVariance: "Varianza del FTA",
	completedTasks: "Tareas completadas",
	closedAssignments: "Asignaciones cerradas",
	acceptedRequests: "Solicitud Aceptada",
	gDSUsage: "Uso de GDS",
	summaryHeaderPartner: "Socio",
	summaryHeaderPpedd: "PPEDD",
	summaryHeaderExecutive: "Ejecutivo",
	financialProgressCard: {
		financialProgress: "Progreso financiero",
		financialDetails: "Detalles financieros",
		ansr: "ANSR",
		nsr: "NSR",
		ansrTooltip: "Ingresos estándar netos ajustados (gastos netos excluyendo los gastos)",
		nsrTooltip: "Ingresos netos estándar (tarifas estándar netas individuales multiplicadas por horas)",
		eafTooltip: "Factor de ajuste del compromiso",
		cost: "Costo",
		hours: "Horas",
		expandDetails: "Ampliar detalles",
		expand: "Expandir",
		collapse: "Contraer",
		collapseDetails: "Contraer detalles",
		margin: "Margen",
		marginPercentage: "Margen",
		rphAcronym: "RPH",
		cphAcronym: "Cph",
		mphAcronym: "Mph",
		eafAcronym: "EAF",
		actual: "Actual",
		budgeted: "Presupuestado",
		forecasted: "Proyecatado",
		ftaVariance: "Varianza del FTA",
		ftaVarianceTooltip: "Previsión de la varianza real",
		rph: "Tarifa por hora",
		cph: "Costo por hora",
		mph: "Margen por hora",
		ansrCost: "NSR / Costo",
		serviceLine: "Línea de servicio",
		subServiceLine: "Línea de subservicio",
		teamMember: "Miembro del equipo",
		totalAnsr: "Total NSR",
		totalCost: "Costo total",
		totalHours: "Total de horas",
		ansrLabelText: "Ingreso estándar neto",
		rank: "Rango",
		performanceActuals: "Rendimiento real"
	},
	financialAnalysis: {
		show: "Mostrar",
		first: "Primero",
		last: "Último",
		previous: "Anterior",
		next: "Próximo"
	},
	financialFilters: {
		serviceLine: "Línea de servicio",
		subServiceLine: "Línea de subservicio",
		rank: "Rango",
		teamMember: "Miembro del equipo",
		showMore: "Más",
		clear: "Borrar",
		clearAll: "Limpiar todo",
		search: "Buscar",
		noResultsPlaceholder: "No hay resultados",
		noFiltersAvailable: "Sin filtros",
		yes: "Sí",
		no: "No",
		tooltip: "Filtrar",
		expenseType: "Tipo de gasto"
	},
	billingAndExpenses: {
		title: "Facturación real hasta la fecha",
		forecastedTer: "TER pronosticado",
		forecastedTerTooltip: "Ingresos totales esperados por participación (tarifas + gastos)",
		forecastedBilling: "Facturación prevista",
		collected: "Cobrado",
		collectedTooltip: "Cobrado / Facturado",
		unCollected: "Sin recolectar",
		unCollectedTooltip: "Sin cobrar / Facturado",
		billed: "Facturado (Pendiente)",
		billedTooltip: "TER facturado / pronosticado",
		billedTotal: "Facturado",
		unbilled: "Sin facturar",
		unbilledTooltip: "TER no facturado / pronosticado",
		engagementCode: "Código de compromiso",
		invoiceDate: "Fecha de la factura",
		currency: "Divisa",
		invoiceNumber: "Número de factura",
		amount: "Importe",
		noInformationPlaceholder: "No hay información disponible para las opciones seleccionadas.",
		actualTer: "TER actual",
		actualTerTooltip: "Ingresos totales reales de participación (tarifas + gastos)",
		actualExpenseToDate: "Gastos reales hasta la fecha",
		displayBy: "Mostrar datos por",
		expenseType: "Tipo de gasto",
		teamMember: "Miembro del equipo",
		totalExpenseToDate: "Gastos totales hasta la fecha",
		expenseTypeColumn: "Tipo de gasto",
		teamMemberColumn: "Miembro del equipo",
		globalExpenseAmount: "Importe global de los gastos",
		localExpenseAmount: "Monto del gasto local",
		billingSummary: "Resumen de facturación",
		billingStatus: "Estado de facturación",
		billingTER: "TER",
		serviceLine: "Línea de servicio",
		serviceLineColumn: "Línea de servicio",
		rank: "Rango",
		rankColumn: "Rango"
	},
	independence: {
		teamMember: "Miembro del equipo",
		hoursCharged: "Horas cargadas",
		independenceStatus: "Situación general de Independencia",
		confirmationDate: "Fecha de confirmación",
		memberFirm: "Firma miembro",
		eyCanvasIndependenceStatus: "Estado de Independencia de EY Canvas",
		employmentStatus: "Situación laboral",
		country: "País",
		updatedBy: "Actualizado por",
		updatedDate: "Fecha de actualización",
		selectColumns: "Seleccione las columnas",
		confirmationDateBefore: "Fecha de confirmación antes",
		confirmationDateAfter: "Fecha de confirmación después",
		excelsummary: "Resumen",
		excelMercury: "Datos de Mercury",
		excelCanvas: "Datos de Canvas",
		name: "Nombre",
		gui: "GUI",
		rank: "Rango",
		emailAddress: "Dirección de correo electrónico",
		clarification: "Clarificación",
		explanation: "Explicación",
		updatedOn: "Actualizado en",
		client: "Cliente",
		mercuryEngagementCode: "código de compromiso de Mercury",
		canvasEngagement: "Compromiso del Canvas",
		email: "Correo electrónico",
		reason: "Razón",
		engagementRole: "Rol de compromiso",
		location: "Ubicación",
		filter: {
			unassociatedFinancialCodes: "Códigos financieros no asociados",
			unassociatedLabel: "No asociado",
			filterHeader: "Filtro de independencia",
			noFinancialCodeLabel: "No hay código financiero asociado",
			noEngagementLabel: "No hay compromiso de EY Canvas asociado",
			expandText: "Expandir",
			collapseText: "Colapsar",
			noDataFound: "No se han encontrado datos"
		}
	},
	header: {
		hours: "Horas",
		actualHours: "Actual",
		forecastedHours: "Previsto",
		variance: "Varianza del FTA",
		other: "Otros",
		ppedd: "PPEDD",
		mgrSrMgr: "SrMgr/Mgr",
		partnerHours: "Horas Socio",
		executiveDirector: "Director Ejecutivo",
		seniorManager: "Senior Manager",
		manager: "Manager",
		senior: "Senior",
		staff: "Staff",
		intern: "Pasante",
		billed: "Facturado:",
		ter: "TER:",
		forecastedTER: "Previsto TER:",
		margin: "Margen",
		ansr: "ANSR",
		cost: "Costo",
		terSection: "TER",
		billedSection: "Facturado",
		forecastedTERSection: "Pronosticado",
		forecastedTERSectionForHeader: "TER pronosticado",
		completedTasks: "Tareas completadas",
		completedAssignments: "Asignaciones cerradas",
		acceptedRequests: "Solicitud Aceptada",
		gdsUsage: "Uso de GDS",
		completedTasksTooltip: "Completado",
		totalTasksTooltip: "Total",
		completedAssignmentsTooltip: "Cerrado",
		totalAssignmentsTooltip: "Total",
		acceptedRequestsTooltip: "Aceptado",
		sentRequestsTooltip: "Enviado",
		gdsHoursTooltip: "GDS",
		actualHoursTooltip: "Horas Actuales",
		otherTooltip: "Otro",
		otherHeaderTooltip: "Otro",
		ppeddTooltip: "PPEDD",
		mgrSrMgrTooltip: "SrMgr/Mgr",
		partnerHoursTooltip: "Socio/Principal",
		executiveDirectorTooltip: "ED/D",
		seniorManagerTooltip: "Gerente Sr.",
		managerTooltip: "Gerente",
		seniorTooltip: "Senior",
		staffTooltip: "Staff",
		internTooltip: "Interno",
		varianceTooltip: "Pronóstico a la varianza real",
		ansrTooltip: "Ingresos estándar netos ajustados (gastos netos excluyendo los gastos)",
		marginTooltip: "Margen = (ANSR - Costo) / ANSR",
		terSectionHover: "Ingresos totales reales de participación (tarifas + gastos)",
		forecastedTERSectionHover: "Ingresos totales de compromiso previstos (honorarios + gastos)",
		billedSectionHover: "Importe neto real de la factura",
		gdsUsageHover: "Uso del servicio de entrega global"
	}
};

export const exportOptions = {
	buttonText: "exportar",
	downloadCSV: "Descargar CSV",
	downloadJPEG: "Descargar JPEG",
	downloadPDF: "Descargar PDF",
	downloadPNG: "Descargar PNG",
	downloadSVG: "Descargar SVG",
	downloadXLS: "Descargar XLS",
	exitFullscreen: "Salir de pantalla completa",
	viewFullscreen: "Ver pantalla completa",
	printChart: "Imprimir gráfico"
};

export const adminLabels = {
	adminPortal: "Administración",
	usersTab: "Administrar usuarios",
	projectsTab: "Gestionar proyectos",
	administrators: "Administrar administradores"
};

export const projectUserStatus = {
	active: "Activo",
	inactive: "Inactivo"
};

export const projectUserRoles = {
	defaultUser: "Usuario predeterminado",
	projectAdministrator: "Administrador de proyectos"
};

export const projectStatus = {
	active: "Activo",
	deleted: "Borrado"
};

export const administratorRoles = {
	none: "Ninguno",
	adminReader: "Lector de administración",
	adminWriter: "Escritor de administración",
	superAdmin: "Súper administrador"
}

export const addUser = {
	firstName: "Nombre",
	lastName: "Apellido",
	enterFirstNameText: "Ingrese el nombre, apellido o dirección de correo electrónico del usuario y presione enter para buscar",
	selectRole: "Rol",
	userRole: "Rol de usuario",
	clear: "Claro",
	email: "Correo electrónico",
	role: "Rol",
	cancel: "Cancelar",
	addUser: "Agregar usuario",
	close: "Cerrar",
	add: "Agregar",
	addAdministrator: "Agregar administrador",
	error1: "El usuario seleccionado ya forma parte del proyecto. Por favor revise.",
	error2: "El administrador solo puede ser una cuenta de usuario privilegiada"
};

export const adminManageProjects = {
	manageProjects: "Gestionar proyectos",
	description: "Buscar un proyecto introduciendo el ID del proyecto",
	projectId: "ID del proyecto",
	search: "Buscar",
	clearSearch: "Borrar",
	enterValidProject: "Introduzca un ID de proyecto válido",
	projectDetails: "Detalles del proyecto",
	enterProjectName: "Introduzca el nombre del proyecto",
	projectName: "Nombre del proyecto",
	projectStatus: "Estado del proyecto",
	financialCodes: "Códigos financieros",
	noFinancialCodes: "No se asignan códigos de compromiso financiero a este proyecto",
	engagementCode: "Código de compromiso",
	client: "Cliente",
	status: "Estado",
	validatedBy: "Validado por",
	canvasEngagements: "Compromisos de EY Canvas",
	canvasEngagement: "Compromiso de EY Canvas",
	noCanvasEngagements: "No hay compromisos de EY Canvas asignados a este proyecto",
	member: "Miembros",
	gui: "GUI",
	firstName: "Nombre",
	lastName: "Apellido",
	emailAddress: "Dirección de correo electrónico",
	userRole: "Rol de usuario",
	validated: "Validado",
	unvalidated: "Sin validar",
	enterValidGui: "Escriba una GUI válida para el ID de proyecto",
	requiredProjectName: "El nombre del proyecto no puede estar en blanco",
	successToastMessage: "Cambios guardados correctamente",
	resetToastMessage: "Restablecimiento completado",
	errorToastMessage: "Se requiere que al menos un miembro del proyecto sea administrador del proyecto. Por favor, revise los cambios.",
	independenceOnly: "Solo independencia",
	yes: "Sí",
	no: "No"
};

export const manageAdministrators = {
	title: "Administrar administradores",
	firstName: "Nombre",
	lastName: "Apellido",
	email: "Correo electrónico",
	role: "Rol",
	description: "Agregar nuevos administradores o administrar administradores existentes",
	noInformationPlaceholder: "No hay información disponible para las opciones seleccionadas.",
	updateAdminErrorToast: "La actualización no se realizó correctamente. Revise e inténtelo de nuevo más tarde.",
	updateAdminSuccessToast: "Cambios guardados correctamente",
};

export const adminManageUsers = {
	title: "Administrar usuarios",
	description: "Buscar un usuario introduciendo su GUI de usuario",
	inputLabel: "GUI de usuario",
	searchButtonLabel: "Buscar",
	cancelButtonLabel: "Claro",
	errorMessage: "Introduzca una GUI de usuario válida",
	userDetails: "Datos del usuario",
	projects: "Proyectos",
	delegates: "Delegados",
	settings: "Configuración",
	noResultsPlaceholder: "No se han encontrado registros",
	delegatedTo: "Delegado en:",
	delegatedFrom: "Delegado de:",
	gui: "GUI (en inglés",
	firstName: "Nombre",
	lastName: "Apellido",
	emailAddress: "Dirección de correo electrónico",
	projectName: "Nombre del proyecto",
	projectId: "ID del proyecto"
};

export const adminCommon = {
	save: "Salvar",
	reset: "Restablecimiento"
}
